import { styled, Box } from "@mui/material";

export const StyledWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
})) as typeof Box;
